import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Platform',
    href: '#platform'
  }, {
    name: 'Capabilities',
    href: '#capabilities'
  }, {
    name: 'Security',
    href: '#security'
  }, {
    name: 'About Us',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/90 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-173">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-174">
        {/* Logo */}
        <div className="flex items-center gap-2 cursor-pointer" data-id="element-175">
          <img src="https://cdn.magicpatterns.com/uploads/4MwpWUASBxAuCwNdk51yeZ/fiqis3.png" alt="FIQIS Logo" className="w-9 h-9 object-contain" data-id="element-176" />
          <span className="text-xl font-bold tracking-wider text-white" data-id="element-177">
            FIQIS
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-178">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white transition-colors" data-id="element-179">
              {link.name}
            </a>)}
          <button className="bg-teal hover:bg-teal-400 text-navy font-semibold px-5 py-2.5 rounded-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(0,212,170,0.4)] text-sm" data-id="element-180">
            Request Demo
          </button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-181">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-182" /> : <MenuIcon className="w-6 h-6" data-id="element-183" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-184">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-slate border-b border-white/10 overflow-hidden" data-id="element-185">
            <div className="px-6 py-4 flex flex-col gap-4" data-id="element-186">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-gray-300 hover:text-white py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-187">
                  {link.name}
                </a>)}
              <button className="bg-teal text-navy font-semibold px-5 py-3 rounded-md mt-2 w-full" data-id="element-188">
                Request Demo
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}